import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=2ed720c6&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports